import useFetch from '../../hooks/useFetch';
import { getSiteSettings } from '../../services/api';
import ContactForm from '../../components/forms/ContactForm';
import SocialLinks from '../../components/SocialIcons';

const FALLBACK_CONTACT = {
  email: 'info@nationwholesalellc.com',
  phone: '(213) 874-8192',
  hours: 'Mon–Fri: 9 AM – 6 PM EST',
  address: 'USA',
};

/**
 * InfoBlock — a single contact-detail row (icon + label + value).
 */
function InfoBlock({ icon, label, children }) {
  return (
    <div className="contact-info-item">
      <div className="contact-info-icon" aria-hidden="true">
        {icon}
      </div>
      <div>
        <div className="contact-info-label">{label}</div>
        <div className="contact-info-value">{children}</div>
      </div>
    </div>
  );
}

function Contact() {
  const { data: settings } = useFetch(() => getSiteSettings(), []);
  const contact = settings?.contact || {};
  const socials = Array.isArray(settings?.socials) ? settings.socials : [];

  const address = contact.address || FALLBACK_CONTACT.address;
  const phone = contact.phone || FALLBACK_CONTACT.phone;
  const email = contact.email || FALLBACK_CONTACT.email;
  const hours = contact.hours || FALLBACK_CONTACT.hours;
  const telHref = `tel:+1${phone.replace(/\D/g, '')}`;

  return (
    <main>
      {/* PAGE HEAD */}
      <div className="page-head">
        <div className="page-head-inner">
          <p className="label">Get In Touch</p>
          <h1>Contact Us</h1>
          <p>
            Have a question about wholesale pricing, documentation, or your
            order? Send us a message and our team will get back to you.
          </p>
        </div>
      </div>

      <div className="products-wrap">
        <div className="contact-grid">
          {/* LEFT: message form */}
          <div className="contact-form-card">
            <ContactForm />
          </div>

          {/* RIGHT: details + socials */}
          <div className="contact-info">
            <h2 className="contact-info-heading">Contact Information</h2>
            {contact.description && (
              <p className="contact-info-desc">{contact.description}</p>
            )}

            <InfoBlock icon="📍" label="Location">
              {address}
            </InfoBlock>
            <InfoBlock icon="📞" label="Phone">
              <a href={telHref}>{phone}</a>
            </InfoBlock>
            <InfoBlock icon="✉️" label="Email">
              <a href={`mailto:${email}`}>{email}</a>
            </InfoBlock>
            <InfoBlock icon="🕑" label="Opening Hours">
              {hours}
            </InfoBlock>

            {socials.length > 0 && (
              <div className="contact-social">
                <div className="contact-info-label">Social Media</div>
                <SocialLinks links={socials} />
              </div>
            )}
          </div>
        </div>

        {/*
          MAP — commented out for now. Enable by uncommenting; it uses the
          admin-set Google Maps embed URL (contact.map_embed_url).

          {contact.map_embed_url && (
            <div className="contact-map">
              <iframe
                title="Location map"
                src={contact.map_embed_url}
                width="100%"
                height="420"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          )}
        */}
      </div>
    </main>
  );
}

export default Contact;
